import React, { Fragment } from "react";
import styled from "styled-components";
import { Chrono } from "react-chrono";
import { TIMELINE_FONT_COLOR, ACCENT_YELLOW_COLOR, BACKGROUND_COLOR, TEXT_FONT, FONT_COLOR} from '../const'
import {StyledIndividualWrapper, StyledAnchorNames } from './styles'

export const StyledTimeframe = styled.div`
  color: ${FONT_COLOR};
  background-color: ${BACKGROUND_COLOR};
  font-size: 2vw; 
  font-family: ${TEXT_FONT};
`

const workExperiences = [
    { 
        title: "Quick Base",
        cardSubtitle: "Feb 2020 - Present",
        cardTitle: "Senior Software Engineer",
        cardDetailedText: [
            "Upgrade Angular v1.6.2 to v1.8.2",
            "Lead 4 co-ops team to refresh the Timeline feature",
            "Lead onboarding initiative to accelerate and standardize onboarding process in PD",
            "Update infrastructure to prevent deployment of feature to production"   
        ]
    },
    { 
        title: "Workbar",
        cardSubtitle: "Sep 2017 - Jul 2018",
        cardTitle: "Junior Full Stack Web Developer",
        cardDetailedText: [
            "Built real-time room reservations status system.", 
            "Automated manual tracking of printer codes and off-boarding checklist.",
            "Improved billing system by upgrading Stripe API in both the frontend and backend.",
            "Assisted in upgrading Rails 3 to Rails 4"
        ]   
        
    },
    { 
        title: "MA Eye and Ear Infirmary",
        cardSubtitle: "Feb 2015 - Apr 2017",
        cardTitle: "Certified Ophthalmic Technician",
        cardDetailedText: [   
            "Performed preliminary patient work-ups (medical history, IOPs, visual acuity, and refraction).",
            "Conducted measurements for cataract surgery. ",
            "Streamlined electronic consent form process across entire department to improve clinic flow and organization.",
            "Improved protocol manuals to be used during training.",
            "Train and mentor Co-op students"     
        ]
    },
    { 
        title: "NY Eye and Ear Infirmary of Mount Sinai",
        cardSubtitle: "Oct 2013 - Feb 2015",
        cardTitle: "Ophthalmic Technician",
        cardDetailedText: [
            "Pretested patient for Uveitis, Glaucoma, Retina, and Neuro-ophthalmology eye exams, pre-ops and post-ops.",
            "Conducted OCT, disc photos, slit lamp photos and visual field.",
            "Trained to set up for intravitreal injections, laser surgery, and B-scans"     
        ]
    },
    { 
        title: "Speciality Eyecare",
        cardSubtitle: "Nov 2012 - Aug 2013",
        cardTitle: "Optometric Technician",
        cardDetailedText: [
            "Scribe for annual eye exams, CL follow ups, kertoconus consults and fittings, binocular and glaucoma work up.",
            "Conducted OCT, visual fields, topography, spec mic, and optos.",
            "Performed preliminary patient work-ups (medical history, IOPs, visual acuity, and refraction)"  
        ]
    }
]


//<Chrono items={items}  theme={{primary: "red", secondary: "blue", cardBgColor: "yellow", cardForeColor: "violet" }} />
export const TimelineContainer = () => {
    return (
        <StyledIndividualWrapper> 
            <StyledTimeframe id="Jackie-timeline">
                <StyledAnchorNames name="resume">Resume</StyledAnchorNames>
                <Chrono slideShow={true} items={workExperiences} theme={
                    {
                        "primary": FONT_COLOR,  
                        "secondary": ACCENT_YELLOW_COLOR,
                        "cardBgColor": FONT_COLOR,
                        "cardForeColor": TIMELINE_FONT_COLOR,
                    }
                    } mode="VERTICAL"
                />
            </StyledTimeframe>
        </StyledIndividualWrapper> 
    )
}


export default TimelineContainer;